import Service from "../../AuthService";
import {domain} from "../../../util/Constants";
const OverviewSale = {
    //for seller order
    getPerDay(start_date , end_date , sale_id){
        return Service.get("/sale_per_day?"+
            "sale_id="+sale_id+
            "&start_date="+start_date+
            "&end_date="+end_date)
    },
    //report sale
    downloadCommissionSale(sale_id,start_date,end_date){
        return Service.get(`/invoices/report_commission_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}`);
    },
    downloadPromotionSale(sale_id,start_date,end_date){
        return Service.get(`/invoices/report_promotion_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}`);
    },
    downloadRvSaleReport(sale_id,start_date,end_date){
        return Service.get(`/invoices/report_rv_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}`);
    },
    downloadCnSaleReport(sale_id,start_date,end_date){
        return Service.get(`/invoices/report_cn_sale?sale_id=${sale_id}&start_date=${start_date}&end_date=${end_date}`);
    },
    downloadCustomerSaleReport(sale_id,year){
        return Service.get(`/invoices/report_customer_per_year?sale_id=${sale_id}&year=${year}`);
    },
    downloadProductSaleReport(date){
        return Service.get(`/invoices/report_product_sale?date=${date}`);
    },
};
export default OverviewSale;
